export * from './RegistroPropiedad/Pages/RegistroPropiedad';
export * from './DetalleInmueble/DetalleInmueble';
export * from './Infraestructura/Infraestructura';
export * from './PlusvaliaMinusvalia/PlusvaliaMinusvalia';
export * from './Observaciones/Observacion';
export * from './ValorInmueble/ValorInmueble';
export * from './Anexos/Anexos';